import React from 'react'
import { Field, ErrorMessage } from 'formik'
import { Box, Typography, Icon, RadioGroup } from '@mui/material'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxRadioButton from 'components/custom/AdxRadioButton'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxInfoIcon from 'components/custom/AdxInfoIcon'

const PolicyCyclePeriod = ({ formikBag, editMode, policy }) => {
  const { values, setFieldValue } = formikBag

  return (
    <Box display="flex" flexDirection="column" rowGap={2}>
      <Box display="flex" alignItems="center" columnGap={1}>
        <Typography variant="body1" color="dark-text.main">
          Leave Cycle Period
        </Typography>
        <AdxInfoIcon
          sx={{ ml: 2 }}
          toolTipTitle="Choose how often the leave balance resets: monthly or yearly."
        />
      </Box>
      <RadioGroup
        sx={{ width: '100%' }}
        name="cycle_period"
        value={values.cycle_period}
        onChange={(event) => {
          setFieldValue('cycle_period', event.currentTarget.value)
          if (event.currentTarget.value === 'monthly') {
            setFieldValue('accrual_type', 1)
            setFieldValue('accrual_happen', null)
            setFieldValue('checkboxes.carryForward', false)
            setFieldValue('credit_deduction', false)
          }
        }}
      >
        <AdxFormControlLabel
          disabled={editMode ? true : policy?.status !== 3 ? false : true}
          type="no-fill"
          selected={values.cycle_period}
          value="monthly"
          control={<Field as={AdxRadioButton} />}
          label="Monthly"
          description="This leave will expire at the end of each month"
        />
        <AdxFormControlLabel
          disabled={editMode ? true : policy?.status !== 3 ? false : true}
          type="no-fill"
          selected={values.cycle_period}
          value="yearly"
          control={<Field as={AdxRadioButton} />}
          label="Yearly"
          description="This leave will expire at the end of each year"
        />
      </RadioGroup>
      <ErrorMessage name="cycle_period" component={AdxErrorMessage} />
    </Box>
  )
}

export default PolicyCyclePeriod
